// Product-card "Add to Cart" (snippets/card-atc.liquid). Delegated, so it also covers cards
// injected later (carousels, recently viewed). Lines carry _source=card for attribution.
(() => {
  if (window.__cardAtc) return;
  window.__cardAtc = true;
  const reset = (btn, label) => setTimeout(() => {
    btn.disabled = false; btn.textContent = label; btn.classList.remove('is-loading', 'is-added', 'is-error');
  }, 1800);
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-card-atc]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    const label = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1, properties: { _source: 'card' } }] }),
      });
      if (!res.ok) throw new Error((await res.json()).description || 'add failed');
      const cart = await fetch('/cart.js').then((r) => r.json());
      btn.classList.replace('is-loading', 'is-added');
      btn.textContent = 'Added ✓';
      // Always use the live <cart-popup> element (window.cartPopup can be a stale instance on mobile)
      const popup = document.querySelector('cart-popup');
      if (popup && typeof popup.renderContents === 'function') popup.renderContents(cart, Number(btn.dataset.productId));
      else document.querySelectorAll('[data-cart-icon-bubble] .cart-count-bubble span[aria-hidden]').forEach((el) => { el.textContent = cart.item_count; });
    } catch (err) {
      btn.classList.replace('is-loading', 'is-error');
      btn.textContent = 'Sorry, try again';
      console.warn('[card-atc]', err);
    }
    reset(btn, label);
  });
})();
